import { TermSetId } from '@zg-rentals/ts-id-verification-client';
import { TermSet } from '../../../models';

export function termSetToTermSetId(termSet: TermSet): TermSetId {
  switch (termSet) {
    case TermSet.LandlordScreening:
      return TermSetId.LANDLORD_SCREENING;
    case TermSet.RenterScreening:
      return TermSetId.RENTER_SCREENING;
    default:
      throw new Error(`Unknown TermSet: ${termSet}`);
  }
}
